import { Controller } from "@hotwired/stimulus"

// A build step lands in a background job and says so over a cable. This asks
// again anyway: a dropped socket, a restarted worker or a backgrounded tab all
// leave the page saying "Writing…" for a step that finished minutes ago.
//
// An interval rather than a one-shot: a re-render that does not re-connect the
// controller would otherwise stop the page checking.
export default class extends Controller {
  static values = { interval: { type: Number, default: 6000 } }

  connect() {
    this.timer = setInterval(() => this.askAgain(), this.intervalValue)
    this.onVisible = () => this.askAgain()
    document.addEventListener("visibilitychange", this.onVisible)
  }

  disconnect() {
    clearInterval(this.timer)
    document.removeEventListener("visibilitychange", this.onVisible)
  }

  askAgain() {
    if (document.hidden) return

    if (window.Turbo) {
      window.Turbo.visit(window.location.href, { action: "replace" })
    } else {
      window.location.reload()
    }
  }
}
